import RecommendationBanner from "components/__haim/Common/RecommendationBanner";
import { useTranslation } from "react-i18next";

export function BulkMessageDialogTechnicalTipBanner(): JSX.Element {
  const { t: translate } = useTranslation();

  return (
    <RecommendationBanner
      title={translate("contactsPage.alert.technicalTip")}
      content={translate("contactsPage.alert.technicalTipDescription")}
    />
  );
}
